<template>
    <div class="itemlist-container">
        <transition name="fade" appear mode="out-in">
            <div v-if="loading">
                <jsk-spinner :transparent="true" :static="true">
                    Ładowanie lokalizacji
                </jsk-spinner>
            </div>
            <div v-else>
                <h2>
                    Wyniki wyszukiwania
                    <span class="item-pages">Strona {{page}} z {{pages}}</span>
                </h2>
                <table class="tb1">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Okręg nastawczy</th>
                            <th>Domyślna</th>
                            <th>Akcje</th>
                        </tr>
                    </thead>
                    <transition-group name="table" tag="tbody">
                        <tr v-for="(location, index) in locations" :key="location._id">
                            <td class="n1">
                              {{(page - 1) * 25 + (index + 1)}} 
                            </td>
                            <td>
                               {{location.district}}
                            </td>
                            <td>
                                <div v-if="$store.getters.getUser.permissions == 'admin'">
                                    <button class="btn btn-secondary btn-sm" v-if="location.default === false" @click="makeDefault(location._id)">
                                        Ustaw jako domyślną
                                    </button>
                                    <button class="btn btn-primary btn-sm" v-else>
                                        Lokalizacja domyślna
                                    </button>
                                </div>
                                <div v-else>
                                    <span v-if="location.default === false">NIE</span>
                                    <span v-else>TAK</span>
                                </div>
                            </td>
                            <td>
                                <button 
                                    class="btn btn-danger" 
                                    @click="openModal(location._id, location.district)"
                                    title="Usuń lokalizację"
                                    v-if="$store.getters.getUser.permissions == 'admin'"
                                >
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                                <div style="width: 30px; height: 40px" v-if="$store.getters.getUser.permissions != 'admin'"></div>
                            </td>   
                        </tr>
                    </transition-group>
                    <tr v-if="locations.length == 0" key="noResults">
                        <td colspan="3">Brak wyników wyszukiwania</td>
                    </tr>
                </table>
                <div class="list-navigation" v-if="pages > 1">
                    <div class="jump-group">
                        <router-link 
                            tag="button" 
                            :to="{path: '/locations/1', query }" 
                            class="btn btn-secondary"
                            v-if="page > 1"
                        >
                            Pierwsza strona
                        </router-link>
                        <router-link 
                            class="btn btn-secondary" 
                            :to="{path: '/locations/' + pages, query }" 
                            tag="button"
                            v-if="page < pages"
                        >
                            Ostatnia strona
                        </router-link>
                    </div>
                    <div class="pag-group">
                        <router-link 
                            tag="button" 
                            class="btn btn-secondary" 
                            :to="{path: '/locations/' + (parseInt(page) - 1), query }" 
                            v-if="page > 1"
                        >
                            Poprzednia strona
                        </router-link>
                        <router-link 
                            tag="button" 
                            class="btn btn-secondary" 
                            :to="{path: '/locations/' + (parseInt(page) + 1), query }" 
                            v-if="page < pages"
                        >
                            Następna strona
                        </router-link>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div class="jsk-modal" v-if="locationRemoveModal" @click="locationRemoveModal = false">
                <transition appear name="slide">
                    <div class="jsk-modal-window" @click.stop>
                        <div class="jsk-modal-header">
                            Potwierdzenie usunięcia lokalizacji
                        </div>
                        <div class="jsk-modal-body">
                            Czy na pewno usunąć lokalizację {{locationToRemove}}? Usunąć można tylko lokalizację, do której nie jest przypisany żaden przekaźnik.
                        </div>
                        <div class="jsk-modal-footer">
                            <button class="btn btn-secondary" @click="locationRemoveModal = false"><i class="fas fa-ban"></i> Anuluj</button>
                            <button class="btn btn-danger" @click="removeLocation(locationToRemoveID)"><i class="fas fa-trash-alt"></i> Usuń lokalizację</button>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import jskSpinner from '../components/Spinner.vue' 

export default {
    data(){
        return{
            loading: false,
            locations: [],

            pages: 0,

            newLocation: "",
            newLocationError: false,

            locationRemoveModal: false,
            locationToRemove: "",
            locationToRemoveID: ""
        }
    },
    computed: {
        page(){
            return this.$route.params.num;
        },
        query(){
            return this.$route.query;
        }
    },  
    methods: {
        ...mapActions([
            'GET',
            'POST',
            'DELETE',
            'PUT'
        ]),
        fetchData(spinner){
            if(spinner) this.loading = true;
            
            const url = "/locations?page=" + this.$route.params.num + ((this.query.s)? "&s=" + this.query.s : "") + ((this.query.sort)? "&sort=" + this.query.sort : "&sort=id") + ((this.query.sortDirection)? "&sortDirection=" + this.query.sortDirection : "&sortDirection=desc");

            //console.log(url)
            this.GET({
                url
            })
            .then(res => {
                this.locations = res.data.locations;
                this.pages = res.data.pages;
                if(spinner) this.loading = false;
            })
            .catch(e => {
                console.error(e);
            });
        },
        removeLocation(id){
            this.DELETE({
                url: '/locations/' + id
            })
            .then(res => {
                this.locations.splice(this.locations.findIndex(item => {
                    return item._id == id;
                }), 1);
                this.$store.commit('newSuccess', res.msg);
                this.locationRemoveModal = false;
                this.locationToRemove = "";
                this.locationToRemoveID = "";
            })
            .catch(e => {
                console.error(e);
                this.locationRemoveModal = false;
                this.locationToRemove = "";
                this.locationToRemoveID = "";
            })
        },
        makeDefault(id){
            this.PUT({
                url: '/locations/' + id
            })
            .then(res => {
                let ind = this.locations.findIndex(item => {
                    return item._id == id;
                });
                let ind2 = this.locations.findIndex(item => {
                    return item.default === true;
                });
                this.locations[ind].default = true;
                if(ind2 != -1) this.locations[ind2].default = false;
                this.$store.commit('newSuccess', res.msg);
            })
            .catch(e => {
                console.error(e);
            });
        },
        openModal(id, name){
            this.locationRemoveModal = true;
            this.locationToRemove = name;
            this.locationToRemoveID = id;
        }
    },
    components: {
        jskSpinner
    },
    created(){
        this.fetchData(true);
        this.$parent.$on('refreshLocations', () => {
            this.fetchData(false)
        });

    }
}
</script>

<style lang="scss">
    
</style>